function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { extends as _extends } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import { useState } from 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import _css from '@emotion/css';
import useStores from "../../../hooks/useStores.js";
import DrawableTextField from "./DrawableTextField.js";
import DrawableCheckboxField from "./DrawableCheckboxField.js";
import DrawableSignatureField from "./DrawableSignatureField.js";
import DrawableDottedLineField from "./DrawableDottedLineField.js";
var components = {
  drawingField: DrawableDottedLineField,
  string: DrawableTextField,
  date: DrawableTextField,
  signature: DrawableSignatureField,
  initials: DrawableSignatureField,
  boolean: DrawableCheckboxField
};

var getComponent = function getComponent(pdfStore, field) {
  var _field$data;

  if (field === pdfStore.drawingField) {
    return components.drawingField;
  }

  var type = ((_field$data = field.data) === null || _field$data === void 0 ? void 0 : _field$data.valueType) || 'string';
  return components[type];
};

var determineCursor = function determineCursor(field, pdfStore, selected, resizeHover) {
  var draggingField = pdfStore.draggingField,
      resizingField = pdfStore.resizingField;
  var dragging = draggingField === field;
  var resizing = resizingField === field;

  if (resizeHover || resizing) {
    return 'nwse-resize';
  } else if (dragging) {
    return 'grabbing';
  } else if (selected) {
    return 'grab';
  }

  return 'pointer';
};

var DrawableField = function DrawableField(props) {
  var field = props.field,
      selected = props.selected;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      resizeHover = _useState2[0],
      setResizeHover = _useState2[1];

  var Component = getComponent(pdfStore, field);

  var handleMouseDown = function handleMouseDown() {
    pdfStore.setSelectedField(field);
  };

  var handleHover = function handleHover(e) {
    setResizeHover(/resize-handle/.test(e.target.classList.value));
  };

  return jsx(Component, _extends({
    css:
    /*#__PURE__*/
    _css({
      cursor: determineCursor(field, pdfStore, !!selected, resizeHover)
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    onMouseDown: handleMouseDown,
    onMouseMove: handleHover
  }, props));
};

DrawableField.displayName = "DrawableField";
var DrawableField$1 = observer(DrawableField);
export default DrawableField$1;